import { Container, Grid, makeStyles, Typography } from '@material-ui/core'
import React from 'react'

function Contact(props) {

    const {kontakt} = props

    const useStyles = makeStyles({
        root:{
            marginTop:"50px",
            
        },
    });

    const classes = useStyles();  

    return (
        
        <Container id="kontakt" alignContent="center" style={{width:"80%",marginTop:"20px"}}>
            <hr></hr>
             <Typography align="center" variant="h4" style={{marginTop:"20px",color:"#0E1B4D",fontWeight:"bold"}}> 
             KONTAKT
            </Typography>
            <Typography align="center"  variant="h6"  className={classes.p}>
            Za bilo kakva pitanja ili prijedloge kontaktirajte nas.
                </Typography>
            <Grid container  
            spacing={3}
            direction="row"  
            justify="space-around"   
            alignContent="center" 
            alignItems="center" 
            style={{textAlign:"center",marginTop:"20px"}}>
            <Grid item  lg={4} xs={12} style={{borderRight:"2px solid grey"}}>
            <Typography variant="h6">
            ADRESA
            </Typography>
            <Typography  variant="subtitle1">
            {kontakt[0].value}
            </Typography>
            </Grid>
            <Grid item lg={4} xs={12} style={{borderRight:"2px solid grey"}}>
            <Typography variant="h6">
            TELEFON
            </Typography>
            <Typography  variant="subtitle1">
            {kontakt[1].value}
            </Typography>
            </Grid>
            <Grid item lg={4} xs={12}>
            <Typography variant="h6">
            EMAIL
            </Typography>
            <Typography  variant="subtitle1">
            {kontakt[2].value}
            </Typography>
            </Grid>
            </Grid>
            </Container>
    )
}

export default Contact
